import _get from 'lodash/get';

import store from 'Redux/store';

// Dark Souls and DragonBall images are ready in CDN for when they can be added

const franchises = [
  { name: 'tekken', bgImg: 'Franchise-Images-STREET-FIGHTER.jpg', logo: 'Franchise-Logo-STREET-FIGHTER.png', slug: 'street-fighter', textImg: '', alt: 'Street Fighter' },
  { name: 'street fighter', bgImg: 'Franchise-Images-TEKKEN.jpg', logo: 'Franchise-Logo-TEKKEN.png', slug: 'tekken', textImg: '', alt: 'Tekken' },
  { name: 'rimworld', bgImg: 'Franchise-Images-RIMWORLD.jpg', logo: 'Franchise-Logo-RIMWORLD.png', slug: 'rimworld', textImg: '', alt: 'RimWorld' },
  { name: 'resident evil', bgImg: 'resident-evil-bg.png', logo: 'ResidentEvilLogo.png', slug: 'resident-evil', textImg: '', alt: 'Resident Evil' },
  { name: 'yakuza', bgImg: 'yakuza-bg.jpeg', slug: 'yakuza', logo: 'YakuzaLogo.png', textImg: '', alt: 'Yakuza' },
  { name: 'total war', bgImg: 'total-war-bg.jpeg', slug: 'total-war', logo: 'TotalWarLogo.png', textImg: '', alt: 'Total War' },
  { name: 'tomb raider', bgImg: 'tomb-raider-bg.jpeg', slug: 'tomb-raider', logo: 'TombRaiderLogo.png', textImg: '', alt: 'Tomb Raider' },
  { name: 'monster hunter', bgImg: 'mh-bg.jpg', slug: 'monster-hunter', logo: 'monster-hunter-logo.svg', textImg: '', alt: 'Monster Hunter' },
  { name: 'civilization', bgImg: 'civilization-bg.jpg', slug: 'civilization', logo: 'civilization-logo.svg', textImg: '', alt: 'Civilization' },
  { name: 'destiny', bgImg: 'destiny.jpg', slug: 'destiny', logo: 'destiny-logo.svg', textImg: '', alt: 'Destiny' },
  { name: 'persona', bgImg: 'persona-bg.jpg', slug: 'persona', logo: 'persona-logo.svg', textImg: '', alt: 'Persona' },
  { name: 'the elder scrolls', bgImg: 'elder-scrolls-bg.jpg', slug: 'the-elder-scrolls', logo: 'elder-scrolls-logo.svg', textImg: '', alt: 'The Elder Scrolls' },
  { name: 'borderlands', bgImg: 'borderlands-bg.jpg', slug: 'borderlands', logo: 'borderlands-logo.svg', textImg: '', alt: 'Borderlands' },
  { name: 'doom', bgImg: 'doom-bg.jpg', slug: 'doom', logo: 'doom-logo.svg', textImg: '', alt: 'DOOM' },
  { name: 'warhammer', bgImg: 'warhammer-40000-bg.jpg', slug: 'warhammer-40000', logo: 'warhammer-40000-logo.svg', textImg: '', alt: 'Warhammer 40,000' },
  { name: 'lego', bgImg: 'lego-bg.jpg', slug: 'lego', logo: 'lego-logo-2.svg', textImg: '', alt: 'LEGO' },
  { name: 'star-wars', bgImg: 'star-wars-bg.jpg', slug: 'star-wars', logo: 'star-wars-logo.svg', textImg: '', alt: 'Star Wars' },
  { name: 'jackbox', bgImg: 'jackbox-bg.jpg', slug: 'jackbox', logo: 'jackbox-logo.svg', textImg: '', alt: 'Jackbox Games' },
  { name: 'fallout', bgImg: 'fallout-bg.jpg', slug: 'fallout', logo: 'fallout-logo.svg', textImg: '', alt: 'Fallout' },
];

const getFranchises = () => franchises;

const getRankedFranchises = () => {
  const franchiseRanks = _get(store.getState(), 'franchises.franchiseRanks', []);

  const rankedNames = franchiseRanks.map(r => r.franchise); // from redis
  const absent = franchises.filter(f => !rankedNames.includes(f.name)); // any discrepancies

  const orderedFranchises = rankedNames.map((rn => franchises.find(f => f.name === rn)))
    .filter(Boolean);

  // so that the first 3 franchises we want to feature come back regardless of rank
  return [...absent.slice(0, 3), ...orderedFranchises, ...absent.slice(3)];
};

export {
  getRankedFranchises,
  getFranchises,
};
